module.exports = __webpack_public_path__ + "static/img/activity.be9da53.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/index/activity.png
// module id = 1169
// module chunks = 18